<div class="wrapper">
  <h2>{{"CUSTOMIZER.CHANGES.NAME" | translate}}</h2>
  <span>{{"CUSTOMIZER.CHANGES.THEREARECHANGES"|translate}}</span>
  <div class="list-unstyled">
    @for (change of changes; track change) {
      <div class="change">
        <li>{{change.translateName}}</li>
        <li>&nbsp;</li>
        <li><i [innerHTML]="change.translateName2"></i></li>
      </div>
    }
  </div>
  <p class="grower"></p>
  <div class="text-center form-group">
    <button class="btn btn-primary mr-3" (click)="saveChanges(true)">{{"COMMON.OK"|translate}}</button>
    <button class="btn btn-secondary" (click)="saveChanges(false)">{{"COMMON.CANCEL"|translate}}</button>
  </div>
</div>